module.exports = __webpack_public_path__ + "static/media/Sachiya.d584f242.jpg";